export default __webpack_public_path__ + "815eff9d17bd3757b39995d73f5f8678.png";